import { styled } from '@mui/system'
import { colors, fontSizes } from '../../Constants/consts'
import { FULL_VIDEO_VIEW_HEIGHT } from '../../Constants/video'

export const ModalVidInnerCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  margin: theme.spacing(3, 1, 8),
  overflowY: 'auto',
  minWidth: '80%',
  background: colors.darkBackground,
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(2, 0, 8),
  },
}))

export const LiveVidCon = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: theme.spacing(1, 1, 4),
    minHeight: 460,
    borderRadius: 6,
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(2, 0, 8),
      minHeight: 300,
    },
  }))

  export const MoreVidCon = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(2, 2, 3),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0),
    },
  }))

export const MoreVidCard = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems:'center',
  margin: theme.spacing(2, 4),
  cursor: 'pointer',
  '& img': {
    width: 125,
    borderRadius: 4,
    margin: theme.spacing(0, 2),
    [theme.breakpoints.down('md')]: {
      width: 100,
    },
  },
  [theme.breakpoints.between('sm', 'md')]: {
    margin: theme.spacing(2, 1),
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(2, 0.5),
  },
}))

export const VideoElement = styled('div', {
  shouldForwardProp: (prop) => prop !== '$videoWidth',
})<{ $videoWidth?: string }>(({ $videoWidth }) => ({
  width: $videoWidth ?? '100%',
  maxWidth: '100%',
  display: 'block',
}))

export const VideoErrorContainer = styled('div')(() => ({
  width: '100%',
  height: `${FULL_VIDEO_VIEW_HEIGHT}vh`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: colors.white,
  background: colors.black,
  fontSize: fontSizes.medium,
}))

export const VideoContainer = styled('div')(() => ({
  position: 'relative',
}))

export const videoElementStyle = (videoWidth: string) => ({
  width: videoWidth,
  maxWidth: '100%',
  display: 'block',
})
